<template>
  <div>
    <v-row style="margin: 0px;">
      <v-tabs v-model="tabs" background-color="white" color="secondary" slider-color="secondary">
        <v-tab :v-if="listSettori && listSettori.length > 0" v-for="settore in listSettori" v-bind:key="settore.value"
          @change="idSettore = settore.value" class="mr-3">
          <v-icon class="mr-2">{{
            settore.type === "P"
              ? "mdi-chart-scatter-plot"
              : "mdi-timer-outline"
          }}</v-icon>
          {{ settore.text }}
        </v-tab>
      </v-tabs>
    </v-row>
    <v-row>
      <v-tabs-items style="width: 100%" v-model="tabs" class="transparent tabs-container">
        <v-tab-item style="width: 100%" :v-if="listSettori && listSettori.length > 0" v-for="settore in listSettori"
          v-bind:key="settore.value">
          <v-container class="tableContainer" v-if="garaData && garaData.dettaglio">
            <table class="scoreboard" v-if="garaData.dettaglio.onVote">
              <view-match-score :type="garaData.dettaglio.type" :partecipante="garaData.dettaglio.onVote" />
            </table>

            <table class="scoreboard" v-if="
              garaData.dettaglio.lastRoutine &&
              garaData.dettaglio.lastRoutine.classifica &&
              (!garaData.dettaglio.onVote ||
                garaData.dettaglio.onVote.idGareDettaglio ===
                garaData.dettaglio.lastRoutine.idGareDettaglio)
            ">
              <view-match-score v-for="(partecipante, index) in garaData.dettaglio.lastRoutine
              .classifica" v-bind:key="partecipante.idGarePartecipanti" v-if="index >= from && index <= to"
                :type="garaData.dettaglio.type" :partecipante="partecipante" :place="partecipante.rank" />
            </table>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-row>
    <v-footer class="footer" :padless="true" :fixed="true" height="80" v-if="
      garaData &&
      garaData.dettaglio &&
      garaData.dettaglio.attesa &&
      garaData.dettaglio.attesa.length > 0
    ">
      <v-row justify="center" class="arrivalboard" no-gutters>
        <h1 class="arrivalboard-element primary--text" style="width: calc(50% - 50px)">
          {{
  $t("next_match") + ":&nbsp;" + garaData.dettaglio.attesa[0].ordine
          }}
        </h1>
        <div class="arrivalboard-element primary--text" style="width: 100px">
          <v-avatar size="75">
            <img :src="garaData.dettaglio.attesa[0].avatar" />
          </v-avatar>
        </div>
        <h1 class="arrivalboard-element primary--text" style="width: calc(50% - 50px)">
          {{ garaData.dettaglio.attesa[0].ragSoc }}
        </h1>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import viewMatchScore from "@/widget/viewMatchScore.vue";

export default {
  name: "dashboard-gara",
  props: {
    paramsIdGara: null,
  },
  components: {
    viewMatchScore,
  },
  data() {
    return {
      idGara: null,
      idSettore: null,
      listSettori: [],
      masterId: null,
      tabs: null,
      garaData: [],
      chartPage: -1,
    };
  },
  computed: {
    pageSize() {
      let pageSize = 6;
      if (this.garaData && this.garaData.screenLines) pageSize = this.garaData.screenLines;
      if (
        this.garaData &&
        this.garaData.dettaglio &&
        this.garaData.dettaglio.onVote
      )
        pageSize = pageSize - 1;
      return pageSize;
    },
    maxPage() {
      let maxPage = 0;
      if (
        this.garaData &&
        this.garaData.dettaglio &&
        this.garaData.dettaglio.classifica
      ) {
        maxPage = parseInt(
          this.garaData.dettaglio.classifica.length / this.pageSize
        );
      }
      return maxPage;
    },
    from() {
      let from = this.chartPage * this.pageSize - 1;
      if (from < 0) from = 0;
      return from;
    },
    to() {
      let to = this.from + (this.pageSize - 1);
      return to;
    },
  },
  mounted() {
    if (this.paramsIdGara) {
      this.idGara = this.paramsIdGara;
      this.loadSettori();
    }
  },
  created() {
    let _ = this;
    _.masterId = parseInt(window.myData.masterId);
    _.loadData();
    setInterval(
      function () {
        _.loadData();
      }.bind(this),
      15000
    );
  },

  watch: {
    paramsIdGara: function (newVal, oldVal) {
      // watch it
      if (newVal) {
        this.idGara = newVal;
        this.loadSettori();
      }
    },

    idSettore: function (newVal, oldVal) {
      // watch it
      if (newVal) {
        this.idSettore = newVal;
        this.loadData();
      }
    },
  },
  methods: {
    loadData() {
      let _ = this;
      _.chartPage++;
      if (_.chartPage > _.maxPage) _.chartPage = 0;
      let url = "/auth/eventi/getGara/" + _.idGara + "/" + _.idSettore;
      _.chiamataAxios("GET", url).then(response => {
        _.garaData = response.data;
      });
    },
    loadSettori() {
      let _ = this;
      _.chartPage = -1;
      let url = "/auth/eventi/getGaraSettori/" + _.idGara;
      _.listSettori = [];
      _.chiamataAxios("GET", url).then(response => {
        _.listSettori = response.data;
        _.idSettore = _.listSettori[0].value;
      });
    },
  },
};
</script>
<style scoped>
.tableContainer {
  height: 100vh;
}

table {
  border-collapse: separate;
  border-spacing: 0 15px;
  width: 100%;
}

tr {
  /* margin: 50px; */
  background-color: rgba(255, 255, 255, 0.9);
}

.scoreboard tr td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.scoreboard tr td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.scoreboard td {
  margin: 25px;
  padding: 25px;
}

.arrivalboard {
  position: absolute;
  height: 100%;
  width: 100%;
  justify-content: space-evenly;
}

.arrivalboard-element {
  line-height: 80px;
  text-align: center;
  text-transform: uppercase;
}

.footer {
  padding: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  border-top: none !important;
  position: fixed;
  background-color: white;
}
</style>